import { AssetSuperTypeBase } from './base/asset-super-type-base';

export class AssetSuperType extends AssetSuperTypeBase { }